export default function useLangSiteCode({ props }) {
  const injectSiteCode = inject('activeSiteCode', undefined)

  const { query } = useRoute()
  const innerSiteCode = ref(query.siteCode || query['site_code'] || props.defaultSiteCode)
  const updateSiteCode = (code) => (innerSiteCode.value = code)

  const siteCodeRef = computed(
    () => innerSiteCode.value || props.siteCode || (injectSiteCode && injectSiteCode.value),
  )

  return {
    siteCodeRef,
    updateSiteCode,
  }
}
